import { Camera } from '@phosphor-icons/react';

import { cn } from "@/lib/utils";

interface ImagePlaceholderProps {
  className?: string;
  iconSize?: "sm" | "md" | "lg";
  text?: string;
}

export const ImagePlaceholder = ({ 
  className, 
  iconSize = "md",
  text = "Imagini în curând" 
}: ImagePlaceholderProps) => {
  const iconSizes = {
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12"
  };

  return (
    <div className={cn(
      "w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-muted to-muted/60 text-muted-foreground",
      className
    )}>
      <Camera className={cn(iconSizes[iconSize], "opacity-50")} />
      <span className="mt-2 text-sm font-medium">{text}</span>
    </div>
  );
};

export const hasValidPhoto = (photo: string | undefined | null): boolean => {
  return !!photo && !photo.includes('placeholder.svg');
};
